import { render } from "./TableHeaderSortDropdown.vue?vue&type=template&id=0e8bed4e&scoped=true&ts=true"
import script from "./TableHeaderSortDropdown.vue?vue&type=script&lang=ts"
export * from "./TableHeaderSortDropdown.vue?vue&type=script&lang=ts"

import "./table-header-sort-dropdown.scss?vue&type=style&index=0&id=0e8bed4e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8bed4e"]])

export default __exports__